import type { TCouponModelData } from '@/_models';

export function couponCalculations(coupons: TCouponModelData): number {
  return coupons?.map((c) => parseFloat(c.amount)).reduce((a, b) => a + b, 0) ?? 0;
}
